import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { AccountingZmReportResource } from "@exonn/js-sdk";
import { zmPeriodLabel } from "src/admin/modules/accounting-zm-report/zeitraum.ts";

/**
 * ZM-Meldestand. „Anlegen“ berechnet den Entwurf eines Mandanten und Zeitraums (der
 * Store-Endpunkt ist die Berechnung); ein Meldestand wird nie bearbeitet oder gelöscht –
 * alles andere geschieht über die Aktionen in der Werkzeugleiste.
 */
export const module: ModuleOptions<AccountingZmReportResource> = {
  resource: ResourceEnum.AccountingZmReport,
  bigIcon: <span className={"icon-20-bills"} />,
  smallIcon: <span className={"icon-15-bills"} />,
  disableDelete: true,
  tabs: {
    edit: {
      getTitle: (resource) =>
        `ZM ${zmPeriodLabel(
          resource.period_year,
          resource.period_month,
          resource.period_type,
        )}`,
    },
  },
};
